import React from 'react'

import LeaguesRenameList from './LeaguesRenameList'
import { ViewHeader } from '../common'

const LeaguesRename = () => {


  return (

    <div className="cls-lr-main">
      <ViewHeader
        title={window.I18n.t('clone_leagues_sessions.leagues_rename.title')}
        description={window.I18n.t('clone_leagues_sessions.leagues_rename.description')}
      />
      <LeaguesRenameList />
    </div>
  )
}

export default LeaguesRename
